const tempClicker = document.querySelector("template");
if (tempClicker) {
    // const propertiesClicker = encodeURIComponent(
    //     JSON.stringify([
    //         {
    //             key: "category",
    //             value: "Плиты",
    //         },
    //     ]),
    // );

    // tempClicker.setAttribute("data-match-properties", propertiesClicker);
    // console.log(propertiesClicker);
    const clickerAddItem = () => {
        const clickerButton = document.querySelectorAll(
            ".installation-service-block__modal-button",
        );
        const clickerInput = document.querySelectorAll(
            ".installation-service-block__checkbox-button",
        );
        const label = document.querySelectorAll(".installation-service-block__checkbox-label");
        const costWithDiscount = document.querySelector(".js-shopping-list__cost-title");
        const priceContainer = document.querySelector(".installation-total-block__price-container");
        for (let i = 0; i < clickerButton.length; i++) {
            const span1 = document.createElement("span");
            const span2 = document.createElement("span");
            span2.className = "clicker-text";
            span1.innerHTML = "Профессиональное";
            span2.innerHTML = "подключение";
            clickerButton[i].innerHTML = "";
            clickerButton[i].append(span1, " ", span2, ":");
        }
        for (let i = 0; i < clickerInput.length; i++) {
            clickerInput[i].classList.add("checkbox__input");
        }
        for (let i = 0; i < label.length; i++) {
            const span = document.createElement("span");

            span.className = "checkbox__icon";
            label[i].append(span);
            label[i].classList.add("checkbox");
        }
        if (!costWithDiscount) {
            priceContainer.classList.add("installation-total-block__price-container--position");
        }
    };
    window.installationServiceState = {
        afterInitialization: clickerAddItem,
    };
}
